import UserPreferencesModal from './UserPreferencesModal.json';

export default {
  ar: {
    UserPreferencesModal,
  },
};
